import { apiClient } from '../../common/ApiClient';
import { expand } from 'uri-template-lite';
import { getMutationFn } from '../../common/queryClient/getMutationFn';
import { createApiMutationHook } from '../../common/queryClient/createApiMutationHook';
import { InputDataKey } from '../schema/types';
import { InputDataUrl } from './InputDataUrl';

const deleteInputData = (params: InputDataKey) =>
  apiClient
    .delete<void>(expand(InputDataUrl.INPUT_DATA_DELETE, params))
    .then((response) => response.data);

export const useInputDataDeleteMutation = createApiMutationHook(
  ['input-data-delete'],
  getMutationFn(deleteInputData)
);
